import { FuelSign, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex, FuelSpacer } from '@frete.com/fuel-station-react';
import { dsTheme } from 'constants/styled.contants';
import React from 'react';

const Inactive = () => (
  <FuelFlex
    defaultProps={{
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      customMargin: `${dsTheme.spacing.km16} 0 0`,
    }}
    testId="search-inactive-state"
  >
    <FuelSign size="medium" icon="search" />
    <FuelSpacer orientation="vertical" y="km8" />
    <FuelTypography size="heading-sm" weight="bold" tag="h4" color="neutral-strong">
      Cadastro não ativo na plataforma
    </FuelTypography>

    <FuelFlex defaultProps={{ alignItems: 'center', justifyContent: 'center' }}>
      <FuelTypography size="body-sm">Utilize o campo acima para a busca de outro profissional.</FuelTypography>
    </FuelFlex>
  </FuelFlex>
);

export default Inactive;
